import {useEffect, useState} from 'react';
import {
    VISITED_BRAND_SUGGESTIONS_KEY,
    isVisitedBrandSuggestion,
    markVisitedBrandSuggestion,
    readVisitedBrandSuggestions,
    scheduleVisitedBrandSuggestionsExpiry,
    subscribeVisitedBrandSuggestions
} from '../utils/visitedBrandSuggestions';

export function useVisitedBrandSuggestions() {
    const [visited, setVisited] = useState(readVisitedBrandSuggestions);

    useEffect(() => {
        const sync = () => {
            setVisited(readVisitedBrandSuggestions());
        };

        scheduleVisitedBrandSuggestionsExpiry();

        const unsubscribe = subscribeVisitedBrandSuggestions(sync);
        const onStorage = (event: StorageEvent) => {
            if (event.key === VISITED_BRAND_SUGGESTIONS_KEY || event.key === null) {
                scheduleVisitedBrandSuggestionsExpiry();
                sync();
            }
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                scheduleVisitedBrandSuggestionsExpiry();
                sync();
            }
        };

        window.addEventListener('storage', onStorage);
        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            unsubscribe();
            window.removeEventListener('storage', onStorage);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);

    return {
        isVisited: (article: string, brand: string) =>
            isVisitedBrandSuggestion(visited, article, brand),
        markVisited: markVisitedBrandSuggestion
    };
}
